/**
 * AddButton Component
 *
 * Consistent "Add New" button for admin panels.
 */

import { Plus } from 'lucide-react';

import { Button } from '@/components/ui/button';


/**
 * AddButton - Add new item button
 *
 * @param {Object} props
 * @param {Function} props.onClick - Click handler
 * @param {string} [props.label] - Button label
 * @param {string} [props.className] - Additional CSS classes
 * @param {boolean} [props.disabled] - Whether button is disabled
 */
export function AddButton({
  onClick,
  label = 'Add New',
  className = '',
  disabled = false,
}) {
  return (
    <div className={`flex justify-end ${className}`}>
      <Button
        onClick={onClick}
        disabled={disabled}
        variant="adminPrimary"
      >
        <Plus className="h-4 w-4 mr-2" />
        {label}
      </Button>
    </div>
  );
}

export default AddButton;
